<div class="execution-results-list">
  <div class="results-header">
    <div class="search-container">
      <fa-icon [icon]="icons.faSearch" class="search-icon"></fa-icon>
      <input
        type="text"
        [(ngModel)]="searchText"
        [placeholder]="'SEARCH.PLACEHOLDER.RESULTS' | translate"
        class="search-input" />
      @if (searchText) {
        <button type="button" class="clear-button" (click)="clearSearch()"
          [title]="'FILTER.CLEAR_SEARCH' | translate">
          <fa-icon [icon]="icons.faTimes"></fa-icon>
        </button>
      }
    </div>
  </div>

  <app-item-list
    [items]="filteredItems"
    [loading]="loading"
    [config]="listConfig"
    [hasActiveFilters]="!!searchText"
    (itemClick)="openExecution($event)">
  </app-item-list>
</div>
